import { Box, CircularProgress, Typography } from '@mui/material';

interface LoadingIndicatorProps {
    isLoading: boolean;
    position: 'top' | 'bottom';
    message?: string;
}

export const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({
    isLoading,
    position,
    message = 'Loading...'
}) => {
    if (!isLoading) return null;

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 2,
                gap: 1,
                position: position === 'top' ? 'sticky' : 'relative',
                top: position === 'top' ? 0 : 'auto',
                bottom: position === 'bottom' ? 0 : 'auto',
                backgroundColor: 'rgba(0, 0, 0, 0.05)',
                borderTop:
                    position === 'top'
                        ? '1px solid rgba(255, 255, 255, 0.1)'
                        : 'none',
                borderBottom:
                    position === 'bottom'
                        ? '1px solid rgba(255, 255, 255, 0.1)'
                        : 'none',
                zIndex: 1
            }}
        >
            <CircularProgress size={16} sx={{ color: '#f0b90b' }} />
            <Typography
                variant="caption"
                sx={{
                    color: '#f0b90b',
                    fontSize: '12px'
                }}
            >
                {message}
            </Typography>
        </Box>
    );
};
